module.exports = __webpack_public_path__ + "static/media/Mulish-Light.29486e23.woff2";